import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getProviders(params: any): AxiosPromise {
    const res = EndPointService.get('/providers', { params });
    return res;
}

function getProvidersConfirmedMetrics(params: any): AxiosPromise {
    const res = EndPointService.get('/providers-confirmed-metrics', { params });
    return res;
}


function getProvidersSmall(params: any): AxiosPromise {
    const res = EndPointService.get('/provider-simply-list', { params });
    return res;
}

function getSuperViserProviders(params: any): AxiosPromise {
    const res = EndPointService.get('/user_providers', { params });

    return res;
}

function getProvider(id: number | string): AxiosPromise {
    return EndPointService.get(`/users/${id}`);
}

function deleteProvider(id: number | string): AxiosPromise {
    return EndPointService.delete(`/users/${id}`);
}

function createProvider(payload: any): AxiosPromise {
    return EndPointService.post('/provider/create', payload);
}

function deleteFileProvider(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/user_docs/${fileId}`);
}
function createFilesProvider(data: any): AxiosPromise {
    return EndPointService.post(`/user_docs`, data);
}
function createSignFilesProvider(data: any, id: string | number): AxiosPromise {
    return EndPointService.post(`/provider/sign-doc`, data, {
        params: {
            id,
        },
    });
}
function getFilesProvider(id: string | number): AxiosPromise {
    return EndPointService.get(`/user_docs`, {
        params: {
            'user.id': id,
        },
    });
}

function updateProvider(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/provider/update`, { ...payload, userId: id }, { params: { id } });
}
function patchProvider(payload: any): AxiosPromise {
    return EndPointService.put(`/provider/status`, payload);
}

export default {
    getProviders,
    getProvidersConfirmedMetrics,
    getFilesProvider,
    createFilesProvider,
    createSignFilesProvider,
    deleteFileProvider,
    getProvider,
    getProvidersSmall,
    getSuperViserProviders,
    deleteProvider,
    createProvider,
    updateProvider,
    patchProvider,
};
